<template>
  <div class="paper-choice-no-choice-add" v-loading="loading" element-loading-text="加载中...">
    <template v-if="teacherList.length && paperTypeList.length">
      <div class="cont">
        <el-form label-width="100px" size="mini" label-suffix="：">
          <el-form-item label="导师" required>
            <el-select v-model="form.teacherId" size="mini" placeholder="请选择导师">
              <el-option v-for="item in teacherList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="论文类型" required>
            <el-select v-model="form.paperTypeId" size="mini" placeholder="请选择论文类型">
              <el-option v-for="item in paperTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="研究方向" required>
            <el-input v-model="form.researchDirection" size="mini" placeholder="请输入研究方向"></el-input>
          </el-form-item>
          <el-form-item label="论文题目" required>
            <el-input v-model="form.paperTitle" size="mini" placeholder="请输入论文题目"></el-input>
          </el-form-item>
          <el-form-item label="选题说明">
            <el-input v-model="form.memo" type="textarea" placeholder="请输入选题说明"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class=footer>
        <el-button size="mini" @click="handleCancel">取消</el-button>
        <el-button type="primary" size="mini" :loading="committing" @click="handleSubmit">{{committing ? '提交中...' : '确定'}}</el-button>
      </div>
    </template>
    <Hint v-else v-show="errorMsg">{{errorMsg}}</Hint>
  </div>
</template>

<script>
import Hint from '../../../../../../../elements/Hint.vue'
export default {
  name: 'PaperChoiceNoChoiceAdd',
  components: {
    Hint
  },
  props: {
    paperBatchId: {
      type: String,
      required: true
    },
    extraId: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      committing: false,
      errorMsg: '',
      teacherList: [],
      paperTypeList: [],
      form: {
        teacherId: '',
        paperTypeId: '',
        researchDirection: '',
        paperTitle: '',
        memo: ''
      }
    }
  },
  methods: {
    handleCancel () {
      this.$emit('hidePopover')
    },
    loadData () {
      this.loading = true
      this.$ajax({
        method: 'post',
        url: '/workspace/manager/paper/choice/noChoice/queryPaperTeacher',
        data: this.$qs.stringify({
          paperBatchId: this.paperBatchId
        })
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.teacherList = response.data.teacherList || []
          this.paperTypeList = response.data.paperTypeList || []
          if (!this.teacherList.length || this.paperTypeList.length) {
            this.errorMsg = '暂无数据'
          }
        } else {
          this.errorMsg = response.data.message || '获取数据失败'
        }
      }, () => {
        this.errorMsg = '获取数据失败'
      }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit () {
      const form = this.form
      if (!form.teacherId) {
        this.$message.warning('请选择导师')
        return
      }
      if (!form.paperTypeId) {
        this.$message.warning('请选择论文类型')
        return
      }
      if (!form.researchDirection) {
        this.$message.warning('请输入研究方向')
        return
      }
      if (!form.paperTitle) {
        this.$message.warning('请输入论文题目')
        return
      }
      this.committing = true
      this.$ajax({
        method: 'post',
        url: '/workspace/manager/paper/choice/noChoice/saveGuideTeacher',
        data: this.$qs.stringify(this.$extend({
          studentId: this.extraId,
          paperBatchId: this.paperBatchId
        }, form))
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.$message.success('操作成功')
          this.$emit('hidePopoverAndRefresh')
        } else {
          this.$message.error(response.data.message || '操作失败')
        }
      }, () => {
        this.$message.error('操作失败')
      }).finally(() => {
        this.committing = false
      })
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.loadData()
        } else {
          this.form = {
            teacherId: '',
            paperTypeId: '',
            researchDirection: '',
            paperTitle: '',
            memo: ''
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.paper-choice-no-choice-add{
  height: 100%;
  display: flex;
  flex-direction: column;
  & > .cont{
    flex: 1;
    width: 450px;
    margin: 0 auto;
    padding: 40px 20px 0;
    overflow-y: auto;
  }
  & > .footer{
    padding: 10px 0;
    text-align: center;
    background-color: #fff;
  }
}
</style>
